export const positionFill = {
  position: 'absolute',
  left: 0,
  top: 0,
  right: 0,
  bottom: 0,
};

export const getSharedAssetContainerStyle = (components, { palette = {} } = {}) => ({
  ...positionFill,
  display: 'flex',
  flexDirection: 'column',
  flexWrap: 'nowrap',
  padding: 12,
  boxSizing: 'border-box',

  // name and ID
  '& .cell-description': {
    display: 'flex',
    flexShrink: 0,
    flexGrow: 0,
    justifyContent: 'space-between',
    fontWeight: 600,
    fontSize: 12,
    margin: [12, 4],

    '& .cell-description-name': {
      flexShrink: 1,
      flexGrow: 1,
      overflow: 'hidden',
      marginRight: 12,
    },

    '& .cell-description-id': {
      flexShrink: 0,
      flexGrow: 0,
    },

    '& .highlighted-text': {
      backgroundColor: palette.yellowLight,
    },
  },
});

export const getSharedMultiSelectingCellStyles = (components, { palette = {} } = {}) => ({
  // only show checkbox on overlay if it is NOT in multi-selecting mode
  selectableCardContainerAutoHideCheckbox: {
    '& .cell-image-frame': {
      overflow: 'hidden',
      borderRadius: 6,
    },

    '& .selected-checkbox': {
      visibility: 'hidden',
    },

    '&:hover': {
      '& .selected-checkbox': {
        visibility: 'visible',
        '& .ms-Checkbox-checkbox': {
          border: '2px solid white !important',
        },
        '& .ms-Checkbox-checkmark': {
          color: palette.white,
        },
      },
    },

    '& .visible-checkbox': {
      visibility: 'visible',
      '& .ms-Checkbox-checkbox': {
        border: '2px solid white !important',
      },
      '& .ms-Checkbox-checkmark': {
        color: palette.white,
      },
    },
  },

  selectableCardContainer: {
    '& .cell-image-frame': {
      overflow: 'hidden',
      borderRadius: 6,
    },

    '& .selected-checkbox': {
      visibility: 'visible',
      '& .ms-Checkbox-checkbox': {
        border: '2px solid white !important',
      },
      '& .ms-Checkbox-checkmark': {
        color: palette.white,
      },
    },
  },
});
